<template>
  <v-container fluid>
    <v-row v-for="category in categories" :key="category.name" class="mx-auto">
      <v-col cols="12">
        <h2>{{ category.name }}</h2>
      </v-col>
      <v-col v-for="(item, _key) in category.itens" :key="_key" xs="12" sm="6" md="4" xl="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :id="_key"
            class="d-flex mx-auto my-auto px-2"
            width="352px"
            height="100px"
            :color="hover ? 'grey lighten-2' : 'white'"
            elevation="0"
            :to="item.link"
            :disabled="item.disabled"
          >
            <v-row no-gutters align="center" justify="center">
              <v-col cols="2">
                <v-icon class="d-flex justify-center my-auto" :size="item.icon_size || 40" color="primary">
                  {{ item.icon }}
                </v-icon>
              </v-col>
              <v-col cols="10">
                <v-card-text class="mx-auto my-auto">
                  <div class="subtitle-2" style="word-break: normal">
                    {{ item.name }}
                  </div>
                  <div class="caption text--secondary">
                    {{ item.description }}
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    name: 'PerdasTecnicas',
    mixins: [profilePermissionsMixin],
    data: () => ({
      categories: []
    }),
    mounted() {
      this.setCategories();
    },
    methods: {
      setCategories() {
        let i = 0;
        if (
          this.accessReleased('SEQUENCIAMENTO_ELETRICO') ||
          this.accessReleased('MALHA') ||
          this.accessReleased('FASEAMENTO') ||
          this.accessReleased('MAPAS_CONECTIVIDADE') ||
          this.accessReleased('IDENTIFICACAO_ILHAS_REDES')
        ) {
          this.categories.push({
            name: 'Algoritmos Norven',
            itens: []
          });

          if (this.accessReleased('SEQUENCIAMENTO_ELETRICO')) {
            this.categories[i].itens.push({
              name: 'Sequenciamento Elétrico',
              link: '/perdas-tecnicas/sequenciamento-eletrico/historico',
              description: 'Execute o algoritmo de sequenciamento elétrico do sistema',
              icon: 'mdi-graph'
            });
          }

          if (this.accessReleased('MALHA')) {
            this.categories[i].itens.push({
              name: 'Malha',
              link: '/perdas-tecnicas/malhas/historico',
              description: 'Execute o algoritmo de correção de loops no sequenciamento elétrico',
              icon: 'mdi-graphql'
            });
          }

          if (this.accessReleased('FASEAMENTO')) {
            this.categories[i].itens.push({
              name: 'Faseamento',
              link: '/perdas-tecnicas/faseamento/historico',
              description: 'Execute o algoritmo de correção de faseamento do sistema',
              icon: 'mdi-alphabetical-variant'
            });
          }

          if (this.accessReleased('MAPAS_CONECTIVIDADE')) {
            this.categories[i].itens.push({
              name: 'Mapas de Conectividade',
              link: '/perdas-tecnicas/mapas-conectividade/historico',
              description: 'Gere mapas para encontrar problemas de conectividade na BDGD',
              icon: 'mdi-map-plus'
            });
          }

          if (this.accessReleased('IDENTIFICACAO_ILHAS_REDES')) {
            this.categories[i].itens.push({
              name: 'Identificação de Ilhas nas Redes',
              link: '/perdas-tecnicas/identificacoes-ilhas-redes/historico',
              description: 'Identifique ilhas de rede desconectadas da rede principal na BDGD',
              icon: 'mdi-vector-polygon'
            });
          }
        }

        if (
          this.accessReleased('CARREGAR_BDGD_HISTORICO') ||
          this.accessReleased('PREENCHER_TABELAS_OPERACIONAIS_HISTORICO') ||
          this.accessReleased('PROG_GEOPERDAS_ANEEL') ||
          this.accessReleased('EXTRACOES_GEOPERDAS')
        ) {
          this.categories.push({
            name: 'Algoritmos ANEEL',
            itens: []
          });
          i++;

          if (this.accessReleased('CARREGAR_BDGD_HISTORICO')) {
            this.categories[i].itens.push({
              name: 'Carregar BDGD',
              link: '/perdas-tecnicas/carregar-bdgd/historico',
              description: 'Carregue uma versão da BDGD para um banco de dados GeoPerdas',
              icon: 'mdi-database-import-outline',
              disabled: false
            });
          }

          if (this.accessReleased('PREENCHER_TABELAS_OPERACIONAIS_HISTORICO')) {
            this.categories[i].itens.push({
              name: 'Etapa 17 NVAL',
              link: '/perdas-tecnicas/preencher-tabelas-operacionais/historico',
              description: 'Execute a procedure "Principal" em um banco de dados GeoPerdas',
              icon: 'mdi-table-sync',
              disabled: false
            });
          }

          if (this.accessReleased('PROG_GEOPERDAS_ANEEL')) {
            this.categories[i].itens.push({
              name: 'ProgGeoPerdas ANEEL',
              link: '/perdas-tecnicas/prog-geo-perdas-aneel/historico',
              description: 'Calcule perdas técnicas utilizando o algoritmo oficial da ANEEL',
              icon: 'mdi-flash-alert-outline'
            });
          }

          if (this.accessReleased('EXTRACOES_GEOPERDAS')) {
            this.categories[i].itens.push({
              name: 'Extrações GeoPerdas',
              link: '/perdas-tecnicas/extracoes-geo-perdas/index',
              description: 'Efetue consultas SQL e extraia dados de servidores GeoPerdas',
              icon: 'mdi-database-search'
            });
          }
        }
      }
    }
  };
</script>
